import { get } from './http-calls';
import { memoize } from 'lodash';

export const getReportsDropdowns = memoize(async (isPermissionBased = true) => {
    let res = await get(`Nicol/ScreenDropdown?isPermissionBased=${isPermissionBased}`, {
        useAuthToken: true
    });
    return res;
});
